import { ChevronRight, Edit, FolderOpen, Trash2 } from 'lucide-react';
import type { Proyecto } from '../../types';

interface Props {
  proyecto: Proyecto;
  pendientes: number;
  hechas: number;
  onAbrir: (proyecto: Proyecto) => void;
  onEditar: (proyecto: Proyecto) => void;
  onEliminar: (proyecto: Proyecto) => void;
}

export function TarjetaProyecto({
  proyecto,
  pendientes,
  hechas,
  onAbrir,
  onEditar,
  onEliminar,
}: Props) {
  return (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow flex items-stretch">
      <button
        onClick={() => onAbrir(proyecto)}
        className="flex-1 min-w-0 text-left p-6 flex items-center gap-3 rounded-l-xl hover:bg-amber-50 transition-colors"
      >
        <FolderOpen size={24} className="text-amber-500 shrink-0" />
        <div className="flex-1 min-w-0">
          <h3 className="text-xl font-bold text-gray-800 break-words">{proyecto.nombre}</h3>
          <p className="text-sm text-gray-600 mt-1">
            {pendientes} pendientes • {hechas} hechas
          </p>
        </div>
        <ChevronRight size={20} className="text-gray-400 shrink-0" />
      </button>
      <div className="flex items-center gap-2 pr-4">
        <button
          onClick={() => onEditar(proyecto)}
          className="text-blue-600 hover:text-blue-800 p-2 hover:bg-blue-50 rounded-lg transition-colors"
          title="Renombrar"
        >
          <Edit size={20} />
        </button>
        <button
          onClick={() => onEliminar(proyecto)}
          className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
          title="Borrar proyecto"
        >
          <Trash2 size={20} />
        </button>
      </div>
    </div>
  );
}
